import React, { createContext, useCallback, useContext, useState } from "react";

import PropTypes from "prop-types";

import { useWeezSocket } from "hooks/useWeezSocket";

const Context = createContext(null);

/**
 * This provider listens to theme updates from Daphne and provide it to the app.
 */
export const AdvancedThemeUpdatesProvider = ({ children }) => {
  const [state, setState] = useState({
    css: undefined,
    headerHtml: undefined,
    footerHtml: undefined,
  });

  useWeezSocket(useCallback((event) => {
    if (!event) return;
    const { data: { origin, payload, action } } = event;

    if (origin !== "daphne" || action !== "theme") return;

    const {
      customCss,
      footerHtml,
      footerHtmlEnabled,
      headerHtml,
      headerHtmlEnabled,
    } = payload.advanced ?? {};

    setState({
      css: customCss,
      headerHtml: headerHtmlEnabled ? headerHtml : null,
      footerHtml: footerHtmlEnabled ? footerHtml : null,
    });
  }, []));

  return (
    <Context.Provider value={state}>
      {children}
    </Context.Provider>
  );
};

AdvancedThemeUpdatesProvider.propTypes = {
  children: PropTypes.node,
};

export const useAdvancedThemeUpdates = () => useContext(Context);
